module.exports = __webpack_public_path__ + "static/media/cat-in-space.65e93f8c.svg";